(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swimdays-home-brand-statement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loaderKey = '__swimdaysBrandStatementLoader';

    const loadScript = (src) =>
      new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[data-swimdays-src="${src}"]`);

        if (existing) {
          if (existing.dataset.loaded === 'true') {
            resolve();
            return;
          }

          existing.addEventListener('load', () => resolve(), { once: true });
          existing.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.dataset.swimdaysSrc = src;
        script.addEventListener('load', () => {
          script.dataset.loaded = 'true';
          resolve();
        }, { once: true });
        script.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true });
        document.head.appendChild(script);
      });

    const ensureGsap = async () => {
      if (window.gsap && window.ScrollTrigger) return;

      if (!window[loaderKey]) {
        window[loaderKey] = (async () => {
          await loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js');
          await loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js');
        })();
      }

      await window[loaderKey];
    };

    const splitText = (element) => {
      if (element.dataset.split === 'true') {
        return Array.from(element.querySelectorAll('.swimdays-home-brand-statement__word'));
      }

      const text = element.textContent || '';
      const words = text.trim().split(/\s+/).filter(Boolean);
      const fragment = document.createDocumentFragment();

      element.textContent = '';
      element.setAttribute('aria-label', text.trim());

      for (const word of words) {
        const span = document.createElement('span');
        span.className = 'swimdays-home-brand-statement__word';
        span.textContent = word;
        span.setAttribute('aria-hidden', 'true');
        fragment.appendChild(span);
        fragment.appendChild(document.createTextNode(' '));
      }

      element.appendChild(fragment);
      element.dataset.split = 'true';

      return Array.from(element.querySelectorAll('.swimdays-home-brand-statement__word'));
    };

    const whenNearViewport = (elements, callback) => {
      const targets = Array.from(elements);
      if (!targets.length) return;

      if (!('IntersectionObserver' in window)) {
        callback();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            observer.disconnect();
            callback();
          }
        },
        { rootMargin: '200px 0px', threshold: 0.01 }
      );

      targets.forEach((el) => observer.observe(el));
    };

    const initBrandStatement = async (root = document) => {
      const sections = root.querySelectorAll('[data-swimdays-brand-statement]');
      if (!sections.length) return;

      await ensureGsap();
      if (!(window.gsap && window.ScrollTrigger)) return;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const { gsap, ScrollTrigger } = window;

      gsap.registerPlugin(ScrollTrigger);

      for (const section of sections) {
        if (section.dataset.swimdaysBrandStatementInit === 'true') continue;
        section.dataset.swimdaysBrandStatementInit = 'true';

        const text = section.querySelector('.swimdays-home-brand-statement__text');
        const divider = section.querySelector('.swimdays-home-brand-statement__divider');
        const dividerLines = section.querySelectorAll('.swimdays-home-brand-statement__divider-line');
        const dividerFlower = section.querySelector('.swimdays-home-brand-statement__divider-flower');

        if (!text || !divider || !dividerFlower || !dividerLines.length) continue;

        const syncDividerWidth = () => {
          const textWidth = text.getBoundingClientRect().width;
          const targetWidth = Math.max(140, Math.min(textWidth * 0.8, 360));
          divider.style.setProperty('--divider-width', `${targetWidth}px`);
        };

        syncDividerWidth();
        window.addEventListener('resize', syncDividerWidth);

        if (prefersReducedMotion.matches) {
          dividerLines.forEach((line) => {
            line.style.transform = 'scaleX(1)';
          });
          dividerFlower.style.transform = 'rotate(0deg)';
          continue;
        }

        const words = splitText(text);

        if (words.length) {
          gsap.set(words, {
            opacity: 0.18,
            filter: 'blur(6px)'
          });
        }

        gsap.set(dividerLines, { scaleX: 0 });
        gsap.set(dividerFlower, { rotation: 0 });

        const timeline = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: 'top bottom',
            end: 'center center',
            scrub: true
          }
        });

        if (words.length) {
          timeline.to(words, {
            duration: 1,
            ease: 'none',
            filter: 'blur(0px)',
            opacity: 1,
            stagger: {
              amount: 0.82,
              from: 'start'
            }
          }, 0);
        }

        timeline.to(dividerLines, {
          duration: 1,
          ease: 'none',
          scaleX: 1
        }, 0);

        ScrollTrigger.create({
          trigger: section,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
          onUpdate: (self) => {
            gsap.set(dividerFlower, {
              rotation: self.progress * 360
            });
          }
        });
      }
    };

    const bootBrandStatement = (root = document) => {
      const sections = root.querySelectorAll('[data-swimdays-brand-statement]');
      whenNearViewport(sections, () => initBrandStatement(root));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bootBrandStatement());
    } else {
      bootBrandStatement();
    }

    document.addEventListener('shopify:section:load', (event) => {
      bootBrandStatement(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swimdays-home-collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loaderKey = '__swimdaysHomeCollectionsGsapLoader';

    const loadScript = (src) =>
      new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[data-swimdays-src="${src}"]`);

        if (existing) {
          if (existing.dataset.loaded === 'true') {
            resolve();
            return;
          }

          existing.addEventListener('load', () => resolve(), { once: true });
          existing.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.dataset.swimdaysSrc = src;
        script.addEventListener('load', () => {
          script.dataset.loaded = 'true';
          resolve();
        }, { once: true });
        script.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true });
        document.head.appendChild(script);
      });

    const ensureGsap = async () => {
      if (window.gsap && window.ScrollTrigger) return;

      if (!window[loaderKey]) {
        window[loaderKey] = (async () => {
          await loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js');
          await loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js');
        })();
      }

      await window[loaderKey];
    };

    const whenNearViewport = (elements, callback) => {
      const targets = Array.from(elements);
      if (!targets.length) return;

      if (!('IntersectionObserver' in window)) {
        callback();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            observer.disconnect();
            callback();
          }
        },
        { rootMargin: '240px 0px', threshold: 0.01 }
      );

      targets.forEach((el) => observer.observe(el));
    };

    const initCollections = async (root = document) => {
      const sections = root.querySelectorAll('[data-swimdays-home-collections]');
      if (!sections.length) return;

      await ensureGsap();
      if (!(window.gsap && window.ScrollTrigger)) return;

      const { gsap, ScrollTrigger } = window;
      gsap.registerPlugin(ScrollTrigger);

      sections.forEach((section) => {
        if (section.dataset.swimdaysCollectionsInit === 'true') return;
        section.dataset.swimdaysCollectionsInit = 'true';

        const media = gsap.matchMedia();
        section._swimdaysCollectionsMedia = media;

        media.add('(min-width: 769px)', () => {
          const headings = section.querySelectorAll('.sil-side-heading');
          const triggers = [];

          headings.forEach((heading) => {
            const container = heading.closest('.sil-side');
            if (!container) return;

            const maxTravel = Math.max(0, container.offsetHeight - (heading.offsetTop * 2) - heading.offsetHeight);

            const timeline = gsap.timeline({
              scrollTrigger: {
                trigger: heading,
                start: 'top 45%',
                end: () => `+=${maxTravel}`,
                scrub: true
              }
            });

            timeline.to(heading, {
              y: maxTravel,
              ease: 'none',
              duration: 1
            }, 0);

            timeline.to(heading, {
              color: '#ffffff',
              ease: 'none',
              duration: 0.5
            }, 0.5);

            triggers.push(timeline);
          });

          return () => {
            triggers.forEach((timeline) => timeline.kill());
          };
        });

        media.add('(max-width: 768px)', () => {
          gsap.set(section.querySelectorAll('.sil-side-heading'), { clearProps: 'transform' });
        });
      });
    };

    const destroyCollections = (section) => {
      if (section && section._swimdaysCollectionsMedia) {
        section._swimdaysCollectionsMedia.revert();
        delete section._swimdaysCollectionsMedia;
      }

      if (section) {
        delete section.dataset.swimdaysCollectionsInit;
      }
    };

    const bootCollections = (root = document) => {
      const sections = root.querySelectorAll('[data-swimdays-home-collections]');
      whenNearViewport(sections, () => initCollections(root));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bootCollections());
    } else {
      bootCollections();
    }

    document.addEventListener('shopify:section:load', (event) => {
      bootCollections(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      destroyCollections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swimdays-home-craft"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loaderKey = '__swimdaysHomeCraftGsapLoader';

    const loadScript = (src) =>
      new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[data-swimdays-src="${src}"]`);

        if (existing) {
          if (existing.dataset.loaded === 'true') {
            resolve();
            return;
          }

          existing.addEventListener('load', () => resolve(), { once: true });
          existing.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.dataset.swimdaysSrc = src;
        script.addEventListener('load', () => {
          script.dataset.loaded = 'true';
          resolve();
        }, { once: true });
        script.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true });
        document.head.appendChild(script);
      });

    const ensureGsap = async () => {
      if (window.gsap && window.ScrollTrigger) return;

      if (!window[loaderKey]) {
        window[loaderKey] = (async () => {
          await loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js');
          await loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js');
        })();
      }

      await window[loaderKey];
    };

    const initCraft = async (root = document) => {
      const sections = root.matches && root.matches('[data-swimdays-home-craft]')
        ? [root]
        : Array.from(root.querySelectorAll('[data-swimdays-home-craft]'));
      if (!sections.length) return;

      await ensureGsap();
      if (!(window.gsap && window.ScrollTrigger)) return;

      const { gsap, ScrollTrigger } = window;
      gsap.registerPlugin(ScrollTrigger);

      sections.forEach((section) => {
        if (section.dataset.swimdaysHomeCraftInit === 'true') return;
        section.dataset.swimdaysHomeCraftInit = 'true';

        const craftSection = section;
        const craftMobileHeading = craftSection.querySelector('.craft-mobile-heading');
        const flower = craftSection.querySelector('.craft-flower');
        const title = craftSection.querySelector('.craft-section-title');
        const craftCopy = craftSection.querySelector('.craft-copy');
        const craftNote = craftSection.querySelector('.craft-note');
        const craftNoteText = craftNote ? craftNote.querySelector('p') : null;
        const craftImages = Array.from(craftSection.querySelectorAll('.craft-media-image'));
        const railNumbers = Array.from(craftSection.querySelectorAll('.craft-number-item'));
        const features = Array.from(craftSection.querySelectorAll('.craft-feature'));
        const bigNumbers = Array.from(craftSection.querySelectorAll('.craft-feature-number'));
        const bigNumbersCol = craftSection.querySelector('.craft-feature-numbers-col');

        if (craftImages.length) {
          gsap.set(craftImages, { autoAlpha: 0 });
          gsap.set(craftImages[0], { autoAlpha: 1 });
        }

        if (craftNoteText && !craftNoteText.dataset.split) {
          const noteText = (craftNoteText.textContent || '').trim();
          const noteWords = noteText.split(/\s+/).filter(Boolean);

          craftNoteText.dataset.split = 'true';
          craftNoteText.setAttribute('aria-label', noteText);
          craftNoteText.textContent = '';

          noteWords.forEach((word, index) => {
            const wordWrap = document.createElement('span');
            wordWrap.className = 'craft-note-word';
            wordWrap.setAttribute('aria-hidden', 'true');

            const inner = document.createElement('span');
            inner.className = 'craft-note-word-inner';
            inner.textContent = word;

            wordWrap.appendChild(inner);
            craftNoteText.appendChild(wordWrap);

            if (index < noteWords.length - 1) {
              const gap = document.createElement('span');
              gap.className = 'craft-note-gap';
              gap.setAttribute('aria-hidden', 'true');
              craftNoteText.appendChild(gap);
            }
          });
        }

        const craftNoteWordInners = craftNoteText ? Array.from(craftNoteText.querySelectorAll('.craft-note-word-inner')) : [];
        const media = gsap.matchMedia();
        section._swimdaysHomeCraftMedia = media;

        media.add('(min-width: 768px)', () => {
          const enterTimeline = gsap.timeline({
            scrollTrigger: {
              trigger: craftSection,
              start: 'top 40%',
              toggleActions: 'play reverse play reverse'
            }
          });

          enterTimeline
            .fromTo(flower, { yPercent: -120 }, { yPercent: 0, duration: 1.2, ease: 'power3.out' }, 0)
            .fromTo(title, { yPercent: 120 }, { yPercent: 0, duration: 1.2, ease: 'power3.out' }, 0.2)
            .fromTo(craftCopy, { yPercent: -18, autoAlpha: 0 }, { yPercent: 0, autoAlpha: 1, duration: 1, ease: 'power3.out' }, 0.6)
            .set(craftNote, { autoAlpha: 1 }, 0.72)
            .fromTo(
              craftNoteWordInners,
              { clipPath: 'inset(-100% 100% -100% -50%)', xPercent: -6, autoAlpha: 0 },
              { clipPath: 'inset(-100% -50% -100% -50%)', xPercent: 0, autoAlpha: 1, duration: 0.48, ease: 'power1.out', stagger: 0.085 },
              0.78
            );

          const scrubTimeline = gsap.timeline({
            scrollTrigger: {
              trigger: craftSection,
              start: 'top top',
              end: '+=400%',
              scrub: true
            }
          });

          if (railNumbers.length) {
            scrubTimeline.set(railNumbers, { color: 'rgba(168, 79, 119, 0.28)' }, 0);
            scrubTimeline.set(railNumbers[0], { color: '#A84F77' }, 0);
          }

          features.forEach((feature, index) => {
            const railNumber = railNumbers[index];
            const bigNumber = bigNumbers[index];
            const words = feature.querySelectorAll('.craft-word');
            const subFeatures = feature.querySelectorAll('.craft-sub-feature');
            const startTime = index * 1.5;

            if (index > 0 && craftImages[index]) {
              scrubTimeline.to(craftImages, { autoAlpha: 0, duration: 0.5, ease: 'sine.inOut' }, startTime);
              scrubTimeline.to(craftImages[index], { autoAlpha: 1, duration: 0.5, ease: 'sine.inOut' }, startTime);
            }

            scrubTimeline
              .set(feature, { opacity: 1 }, startTime)
              .fromTo(words, { yPercent: 120 }, { yPercent: 0, duration: 0.8, stagger: 0.1, ease: 'sine.inOut' }, startTime)
              .fromTo(subFeatures, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.8, stagger: 0.1, ease: 'sine.inOut' }, startTime);

            if (bigNumber && bigNumbersCol) {
              scrubTimeline.to(bigNumbersCol, { y: () => -(bigNumber.offsetTop), duration: 0.8, ease: 'sine.inOut' }, startTime);
              scrubTimeline.fromTo(bigNumber, { backgroundPosition: 'top' }, { backgroundPosition: 'bottom', duration: 0.6, ease: 'power2.out' }, startTime + 0.2);
            }

            if (railNumber) {
              scrubTimeline.to(railNumber, { color: '#A84F77', duration: 0.2, ease: 'none' }, startTime);
            }

            if (index < features.length - 1) {
              const exitTime = startTime + 1.2;
              scrubTimeline
                .to(words, { yPercent: -120, duration: 0.8, stagger: 0.05, ease: 'sine.inOut' }, exitTime)
                .to(subFeatures, { opacity: 0, y: -30, duration: 0.8, stagger: 0.05, ease: 'sine.inOut' }, exitTime)
                .set(feature, { opacity: 0 }, exitTime + 0.8 + 0.05 * words.length);

              if (railNumber) {
                scrubTimeline.to(railNumber, { color: 'rgba(168, 79, 119, 0.28)', duration: 0.2, ease: 'none' }, exitTime);
              }

              if (bigNumber) {
                scrubTimeline.to(bigNumber, { backgroundPosition: 'top', duration: 0.6, ease: 'power2.out' }, exitTime);
              }
            }
          });

          const gapDistance = craftNote.offsetTop - craftCopy.offsetTop - craftCopy.offsetHeight - 24;

          if (gapDistance > 0) {
            gsap.to(craftCopy, {
              y: gapDistance,
              ease: 'none',
              scrollTrigger: {
                trigger: craftSection,
                start: 'bottom 100%',
                end: `+=${gapDistance}`,
                scrub: true
              }
            });
          }
        });

        media.add('(max-width: 767px)', () => {
          const introTimeline = gsap.timeline({
            scrollTrigger: {
              trigger: craftSection,
              start: 'top 78%',
              toggleActions: 'play none none reverse'
            }
          });

          introTimeline
            .fromTo(craftMobileHeading, { y: 20, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.65, ease: 'power2.out' }, 0)
            .fromTo(craftCopy, { y: 24, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.65, ease: 'power2.out' }, 0.12);

          features.forEach((feature) => {
            gsap.fromTo(
              feature,
              { y: 36, autoAlpha: 0 },
              {
                y: 0,
                autoAlpha: 1,
                duration: 0.72,
                ease: 'power2.out',
                scrollTrigger: {
                  trigger: feature,
                  start: 'top 88%',
                  toggleActions: 'play none none reverse'
                }
              }
            );
          });
        });
      });
    };

    const destroyCraft = (root) => {
      const sections = root.matches && root.matches('[data-swimdays-home-craft]')
        ? [root]
        : Array.from(root.querySelectorAll ? root.querySelectorAll('[data-swimdays-home-craft]') : []);

      sections.forEach((section) => {
        if (section._swimdaysHomeCraftMedia) {
          section._swimdaysHomeCraftMedia.revert();
          delete section._swimdaysHomeCraftMedia;
        }

        delete section.dataset.swimdaysHomeCraftInit;
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCraft());
    } else {
      initCraft();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initCraft(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      destroyCraft(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swimdays-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSwimdaysHero = (root = document) => {
      const heroes = root.querySelectorAll('.swimdays-home-hero');

      heroes.forEach((hero) => {
        if (hero.dataset.heroInit === 'true') return;
        hero.dataset.heroInit = 'true';

        const slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
        const prevButton = hero.querySelector('[data-hero-prev]');
        const nextButton = hero.querySelector('[data-hero-next]');
        const mobileViewport = window.matchMedia('(max-width: 1023px)');
        let activeIndex = 0;
        let intervalId = null;

        if (slides.length <= 1) {
          hero.querySelector('.swimdays-home-hero__controls')?.setAttribute('hidden', 'hidden');
          return;
        }

        const applySlideState = () => {
          if (!mobileViewport.matches) {
            slides.forEach((slide, index) => {
              slide.classList.toggle('is-active', index === 0);
            });
            return;
          }

          slides.forEach((slide, index) => {
            slide.classList.toggle('is-active', index === activeIndex);
          });
        };

        const resetAutoplay = () => {
          if (intervalId) window.clearInterval(intervalId);
          if (!mobileViewport.matches) return;

          intervalId = window.setInterval(() => {
            activeIndex = (activeIndex + 1) % slides.length;
            applySlideState();
          }, 10000);
        };

        const goToPrevious = () => {
          activeIndex = (activeIndex - 1 + slides.length) % slides.length;
          applySlideState();
          resetAutoplay();
        };

        const goToNext = () => {
          activeIndex = (activeIndex + 1) % slides.length;
          applySlideState();
          resetAutoplay();
        };

        prevButton?.addEventListener('click', goToPrevious);
        nextButton?.addEventListener('click', goToNext);
        mobileViewport.addEventListener('change', () => {
          activeIndex = 0;
          applySlideState();
          resetAutoplay();
        });

        applySlideState();
        resetAutoplay();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initSwimdaysHero());
    } else {
      initSwimdaysHero();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initSwimdaysHero(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swimdays-home-instagram"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SECTION_SELECTOR = '[data-swimdays-home-instagram]';
    const PREVIEW_SELECTOR = '[data-swimdays-instagram-preview]';
    const DESKTOP_HOVER_QUERY = '(hover: hover) and (pointer: fine)';

    const initSection = (scope = document) => {
      const sectionRoots = scope.matches?.(SECTION_SELECTOR) ? [scope] : scope.querySelectorAll?.(SECTION_SELECTOR);
      if (!sectionRoots || !sectionRoots.length) return;

      const canHover = window.matchMedia(DESKTOP_HOVER_QUERY).matches;

      sectionRoots.forEach((section) => {
        section.querySelectorAll(PREVIEW_SELECTOR).forEach((shell) => {
          if (shell.dataset.previewInit === 'true') return;

          const video = shell.querySelector('video');
          if (!video) return;

          shell.dataset.previewInit = 'true';
          video.muted = true;
          video.playsInline = true;

          let stopTimer = null;

          const clearTimer = () => {
            if (stopTimer) {
              window.clearTimeout(stopTimer);
              stopTimer = null;
            }
          };

          const stopPreview = () => {
            clearTimer();
            video.pause();
            try {
              video.currentTime = 0;
            } catch (error) {}
            shell.classList.remove('is-previewing');
          };

          const startPreview = () => {
            if (!canHover) return;

            clearTimer();
            shell.classList.add('is-previewing');
            try {
              video.currentTime = 0;
            } catch (error) {}

            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }

            const seconds = Number(shell.dataset.previewSeconds || 6);
            const durationMs = Math.min(Math.max(seconds, 1), 15) * 1000;
            stopTimer = window.setTimeout(stopPreview, durationMs);
          };

          shell.addEventListener('mouseenter', startPreview);
          shell.addEventListener('mouseleave', stopPreview);
          shell.addEventListener('focusin', startPreview);
          shell.addEventListener('focusout', stopPreview);
          stopPreview();
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initSection(document));
    } else {
      initSection(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target) initSection(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swimdays-home-shop-all-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSwimdaysHomeProducts = (root = document) => {
      const sections = root.querySelectorAll('[data-swimdays-home-shop-all-products]');

      sections.forEach((section) => {
        if (section.dataset.swimdaysProductsInit === 'true') return;
        section.dataset.swimdaysProductsInit = 'true';

        const scroller = section.querySelector('[data-featured-scroller]');
        const prevButton = section.querySelector('.featured-nav-btn.prev');
        const nextButton = section.querySelector('.featured-nav-btn.next');

        if (!scroller || !prevButton || !nextButton) return;

        const setGalleryIndex = (gallery, index) => {
          const size = Number(gallery.dataset.gallerySize);
          if (!Number.isFinite(size) || size < 2) return;

          const nextIndex = ((index % size) + size) % size;
          const card = gallery.closest('.swimdays-product-card');
          if (!card) return;

          gallery.dataset.galleryIndex = String(nextIndex);
          gallery.style.setProperty('--gallery-index', String(nextIndex));

          const nextSlide = card.querySelectorAll('[data-shop-all-gallery-slide]')[nextIndex];
          const nextImage = nextSlide && nextSlide.querySelector('[data-shop-all-gallery-image]');
          if (nextImage && !nextImage.getAttribute('src')) {
            nextImage.src = nextImage.dataset.src || '';
            nextImage.srcset = nextImage.dataset.srcset || '';
          }

          card.querySelectorAll('[data-shop-all-gallery-slide]').forEach((slide, slideIndex) => {
            if (slideIndex === nextIndex) {
              slide.removeAttribute('aria-hidden');
            } else {
              slide.setAttribute('aria-hidden', 'true');
            }
          });

          card.querySelectorAll('[data-shop-all-gallery-dot]').forEach((dot, dotIndex) => {
            if (dotIndex === nextIndex) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        };

        const desktopGalleryMedia = window.matchMedia('(min-width: 1024px) and (hover: hover)');
        const resetGalleriesForCompactView = (event = desktopGalleryMedia) => {
          if (event.matches) return;

          section.querySelectorAll('[data-shop-all-gallery]').forEach((gallery) => {
            setGalleryIndex(gallery, 0);
          });
        };

        desktopGalleryMedia.addEventListener('change', resetGalleriesForCompactView);
        resetGalleriesForCompactView();

        section.addEventListener(
          'shopify:section:unload',
          () => desktopGalleryMedia.removeEventListener('change', resetGalleriesForCompactView),
          { once: true }
        );

        const setGalleryControlsTabbable = (card, tabbable) => {
          card.querySelectorAll('[data-shop-all-gallery-prev], [data-shop-all-gallery-next], [data-shop-all-gallery-dot]').forEach((control) => {
            control.tabIndex = tabbable ? 0 : -1;
          });
        };

        section.querySelectorAll('.swimdays-product-card').forEach((card) => {
          if (!card.querySelector('[data-shop-all-gallery-ui]')) return;

          card.addEventListener('pointerenter', () => {
            if (!desktopGalleryMedia.matches) return;
            setGalleryControlsTabbable(card, true);
          });

          card.addEventListener('focusin', () => {
            if (!desktopGalleryMedia.matches) return;
            setGalleryControlsTabbable(card, true);
          });

          card.addEventListener('pointerleave', () => {
            if (card.contains(document.activeElement)) return;
            setGalleryControlsTabbable(card, false);
          });

          card.addEventListener('focusout', (event) => {
            if (card.contains(event.relatedTarget)) return;
            setGalleryControlsTabbable(card, false);
          });
        });

        section.addEventListener('click', (event) => {
          const control = event.target.closest(
            '[data-shop-all-gallery-prev], [data-shop-all-gallery-next], [data-shop-all-gallery-dot]'
          );
          if (!control || !section.contains(control)) return;

          const card = control.closest('.swimdays-product-card');
          const gallery = card && card.querySelector('[data-shop-all-gallery]');
          if (!gallery) return;

          event.preventDefault();
          event.stopPropagation();

          const currentIndex = Number(gallery.dataset.galleryIndex) || 0;

          if (control.matches('[data-shop-all-gallery-prev]')) {
            setGalleryIndex(gallery, currentIndex - 1);
          } else if (control.matches('[data-shop-all-gallery-next]')) {
            setGalleryIndex(gallery, currentIndex + 1);
          } else {
            setGalleryIndex(gallery, Number(control.dataset.shopAllGalleryDot));
          }
        });

        const getScrollAmount = () => {
          const card = scroller.querySelector('.swimdays-product-card');
          return card ? card.offsetWidth + 2 : 0;
        };

        prevButton.addEventListener('click', () => {
          scroller.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });

        nextButton.addEventListener('click', () => {
          scroller.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initSwimdaysHomeProducts());
    } else {
      initSwimdaysHomeProducts();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initSwimdaysHomeProducts(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swimdays-home-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SECTION_SELECTOR = '[data-swimdays-home-testimonials]';
    const VIEWPORT_SELECTOR = '[data-testimonials-viewport]';
    const RAIL_SELECTOR = '[data-testimonials-rail]';
    const CARD_SELECTOR = '[data-testimonial-card]';
    const LIGHTBOX_SELECTOR = '[data-testimonial-lightbox]';
    const LIGHTBOX_TRIGGER_SELECTOR = '[data-testimonial-lightbox-trigger]';
    const LIGHTBOX_CLOSE_SELECTOR = '[data-testimonial-lightbox-close]';
    const LIGHTBOX_IMAGE_SELECTOR = '[data-testimonial-lightbox-image]';
    const LIGHTBOX_CAPTION_SELECTOR = '[data-testimonial-lightbox-caption]';
    const LIGHTBOX_OPEN_CLASS = 'swimdays-testimonials-lightbox-open';

    const parseDateValue = (card) => {
      const rawDate = card.dataset.testimonialDate || '';
      const parsedDate = Date.parse(rawDate);

      if (Number.isNaN(parsedDate)) return 0;

      return parsedDate;
    };

    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter((element) => element.offsetParent !== null);
    };

    const prepareRail = (rail, viewport) => {
      const cards = Array.from(rail.querySelectorAll(`${CARD_SELECTOR}:not([data-testimonial-clone])`));

      cards
        .sort((firstCard, secondCard) => {
          const dateDiff = parseDateValue(secondCard) - parseDateValue(firstCard);

          if (dateDiff !== 0) return dateDiff;

          const firstIndex = Number(firstCard.dataset.testimonialIndex || 0);
          const secondIndex = Number(secondCard.dataset.testimonialIndex || 0);

          return firstIndex - secondIndex;
        })
        .forEach((card) => rail.appendChild(card));

      rail.querySelectorAll('[data-testimonial-clone]').forEach((clone) => clone.remove());

      if (cards.length < 2) return 0;

      const loopPoint = rail.scrollWidth;
      let clonePasses = 0;

      while (rail.scrollWidth < loopPoint + viewport.clientWidth && clonePasses < 6) {
        for (const card of cards) {
          const clone = card.cloneNode(true);
          Array.from(clone.attributes).forEach((attribute) => {
            if (attribute.name.startsWith('data-shopify')) {
              clone.removeAttribute(attribute.name);
            }
          });
          clone.dataset.testimonialClone = 'true';
          clone.setAttribute('aria-hidden', 'true');

          clone.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
            element.setAttribute('tabindex', '-1');
          });

          rail.appendChild(clone);
        }

        clonePasses += 1;
      }

      return loopPoint;
    };

    const getRailGap = (rail) => {
      const styles = window.getComputedStyle(rail);
      const gap = parseFloat(styles.columnGap || styles.gap || '0');

      if (Number.isNaN(gap)) return 0;

      return gap;
    };

    const initTestimonials = (root = document) => {
      const sections = root.querySelectorAll(SECTION_SELECTOR);

      for (const section of sections) {
        if (section.dataset.testimonialsInitialized === 'true') continue;

        const viewport = section.querySelector(VIEWPORT_SELECTOR);
        const rail = section.querySelector(RAIL_SELECTOR);
        const lightbox = section.querySelector(LIGHTBOX_SELECTOR);

        if (!(viewport && rail)) continue;

        section.dataset.testimonialsInitialized = 'true';

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const speed = Math.max(0, Number(section.dataset.autoplaySpeed || 14));
        const pauseReasons = new Set();
        const state = {
          activeTrigger: null,
          frame: null,
          lastTimestamp: 0,
          loopPoint: prepareRail(rail, viewport),
          paused: reducedMotion.matches || speed === 0,
          position: viewport.scrollLeft,
        };

        const canScroll = () => state.loopPoint > 0 && viewport.scrollWidth > viewport.clientWidth + 2;

        const updatePausedState = () => {
          state.paused = pauseReasons.size > 0 || reducedMotion.matches || speed === 0;
        };

        const pauseFor = (reason) => {
          pauseReasons.add(reason);
          updatePausedState();
        };

        const resumeFor = (reason) => {
          pauseReasons.delete(reason);
          updatePausedState();
        };

        const clearWave = () => {
          rail.querySelectorAll(CARD_SELECTOR).forEach((card) => {
            card.style.setProperty('--testimonial-wave-y', '0px');
          });
        };

        const updateWave = () => {
          const cards = Array.from(rail.querySelectorAll(CARD_SELECTOR));

          if (reducedMotion.matches || cards.length === 0) {
            clearWave();
            return;
          }

          const firstCard = cards[0];
          const firstRect = firstCard.getBoundingClientRect();
          const stride = firstRect.width + getRailGap(rail);

          if (stride <= 0) {
            clearWave();
            return;
          }

          const viewportRect = viewport.getBoundingClientRect();
          const amplitude = viewport.clientWidth < 750 ? 7 : 16;

          cards.forEach((card) => {
            const rect = card.getBoundingClientRect();
            const positionInSlots = (rect.left - viewportRect.left) / stride;
            const offset = Math.cos(positionInSlots * Math.PI) * -amplitude;

            card.style.setProperty('--testimonial-wave-y', `${offset.toFixed(2)}px`);
          });
        };

        const tick = (timestamp) => {
          if (!state.lastTimestamp) state.lastTimestamp = timestamp;

          const delta = timestamp - state.lastTimestamp;
          state.lastTimestamp = timestamp;

          if (!state.paused && canScroll()) {
            state.position += (speed * delta) / 1000;

            if (state.position >= state.loopPoint) {
              state.position -= state.loopPoint;
            }

            viewport.scrollLeft = state.position;
          } else {
            state.position = viewport.scrollLeft;
          }

          updateWave();

          state.frame = window.requestAnimationFrame(tick);
        };

        const handleReducedMotion = () => {
          updatePausedState();
          updateWave();
        };
        const pausePointer = () => pauseFor('pointer');
        const resumePointer = () => {
          state.position = viewport.scrollLeft;
          resumeFor('pointer');
        };
        const pauseFocus = () => pauseFor('focus');
        const resumeFocus = (event) => {
          if (event.relatedTarget && viewport.contains(event.relatedTarget)) return;

          state.position = viewport.scrollLeft;
          resumeFor('focus');
        };
        const handleScroll = () => {
          if (state.paused) {
            state.position = viewport.scrollLeft;
          }

          updateWave();
        };
        const handleResize = () => {
          state.position = viewport.scrollLeft;
          state.loopPoint = prepareRail(rail, viewport);
          updateWave();
        };
        const closeLightbox = () => {
          if (!lightbox || lightbox.hidden) return;

          const image = lightbox.querySelector(LIGHTBOX_IMAGE_SELECTOR);
          const caption = lightbox.querySelector(LIGHTBOX_CAPTION_SELECTOR);
          const trigger = state.activeTrigger;

          lightbox.hidden = true;
          lightbox.removeAttribute('data-open');
          document.documentElement.classList.remove(LIGHTBOX_OPEN_CLASS);
          resumeFor('lightbox');

          if (image) {
            image.removeAttribute('src');
            image.alt = '';
          }

          if (caption) {
            caption.textContent = '';
          }

          state.activeTrigger = null;

          if (trigger && document.contains(trigger)) {
            trigger.focus({ preventScroll: true });
          }
        };
        const openLightbox = (trigger) => {
          if (!lightbox || !trigger) return;

          const image = lightbox.querySelector(LIGHTBOX_IMAGE_SELECTOR);
          const caption = lightbox.querySelector(LIGHTBOX_CAPTION_SELECTOR);
          const closeButton = lightbox.querySelector(LIGHTBOX_CLOSE_SELECTOR);
          const src = trigger.dataset.testimonialLightboxSrc;

          if (!(image && src)) return;

          state.activeTrigger = trigger;
          image.src = src;
          image.alt = trigger.dataset.testimonialLightboxAlt || '';

          if (caption) {
            caption.textContent = trigger.dataset.testimonialLightboxCaption || '';
          }

          lightbox.hidden = false;
          lightbox.setAttribute('data-open', 'true');
          document.documentElement.classList.add(LIGHTBOX_OPEN_CLASS);
          pauseFor('lightbox');

          if (closeButton) {
            closeButton.focus({ preventScroll: true });
          }
        };
        const handleSectionClick = (event) => {
          const closeTrigger = event.target.closest(LIGHTBOX_CLOSE_SELECTOR);

          if (closeTrigger && lightbox && lightbox.contains(closeTrigger)) {
            closeLightbox();
            return;
          }

          const lightboxTrigger = event.target.closest(LIGHTBOX_TRIGGER_SELECTOR);

          if (lightboxTrigger && section.contains(lightboxTrigger)) {
            event.preventDefault();
            openLightbox(lightboxTrigger);
          }
        };
        const handleKeydown = (event) => {
          if (!lightbox || lightbox.hidden) return;

          if (event.key === 'Escape') {
            event.preventDefault();
            closeLightbox();
            return;
          }

          if (event.key !== 'Tab') return;

          const focusableElements = getFocusableElements(lightbox);

          if (focusableElements.length === 0) return;

          const firstElement = focusableElements[0];
          const lastElement = focusableElements[focusableElements.length - 1];

          if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
          } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
          }
        };

        viewport.addEventListener('pointerenter', pausePointer);
        viewport.addEventListener('pointerleave', resumePointer);
        viewport.addEventListener('focusin', pauseFocus);
        viewport.addEventListener('focusout', resumeFocus);
        viewport.addEventListener('scroll', handleScroll, { passive: true });
        section.addEventListener('click', handleSectionClick);
        document.addEventListener('keydown', handleKeydown);
        window.addEventListener('resize', handleResize);
        reducedMotion.addEventListener('change', handleReducedMotion);

        updateWave();
        state.frame = window.requestAnimationFrame(tick);
        section._swimdaysTestimonialsCleanup = () => {
          closeLightbox();
          if (state.frame) window.cancelAnimationFrame(state.frame);
          viewport.removeEventListener('pointerenter', pausePointer);
          viewport.removeEventListener('pointerleave', resumePointer);
          viewport.removeEventListener('focusin', pauseFocus);
          viewport.removeEventListener('focusout', resumeFocus);
          viewport.removeEventListener('scroll', handleScroll);
          section.removeEventListener('click', handleSectionClick);
          document.removeEventListener('keydown', handleKeydown);
          window.removeEventListener('resize', handleResize);
          reducedMotion.removeEventListener('change', handleReducedMotion);
          rail.querySelectorAll('[data-testimonial-clone]').forEach((clone) => clone.remove());
          delete section.dataset.testimonialsInitialized;
        };
      }
    };

    const cleanupTestimonials = (section) => {
      if (section && section._swimdaysTestimonialsCleanup) {
        section._swimdaysTestimonialsCleanup();
        delete section._swimdaysTestimonialsCleanup;
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initTestimonials());
    } else {
      initTestimonials();
    }

    document.addEventListener('shopify:section:load', (event) => initTestimonials(event.target));
    document.addEventListener('shopify:section:unload', (event) => cleanupTestimonials(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
